import * as React from 'react'
import { useState } from 'react'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { Box, Button, Link, Typography } from '@mui/material'
import firebase from 'infrastructure/firebase'
import { GoogleLoginButton } from 'infrastructure/googleDrive'
import { useExportStandardsToSheet } from './hooks'
import { kiddomStandardsAtom } from './atoms'

interface ExportStandardsToSheetProps {
  state: string
  subjectName: string
}

function ExportButtonContent({
  state,
  subjectName,
}: {
  state: string
  subjectName: string
}) {
  const [kiddomStandards] = useAtom(kiddomStandardsAtom)
  const { exportToSheet, loadingExport } = useExportStandardsToSheet()
  const [spreadsheetId, setSpreadsheetId] = useState<string | null>(null)

  const standards = kiddomStandards?.data || []

  const handleExport = async () => {
    const id = await exportToSheet(standards, state, subjectName)
    if (id) {
      setSpreadsheetId(id)
    }
  }

  const spreadsheetUrl = spreadsheetId
    ? `https://docs.google.com/spreadsheets/d/${spreadsheetId}/edit`
    : null

  return (
    <Box sx={{ mt: 1 }}>
      <Button
        variant="text"
        size="small"
        onClick={handleExport}
        disabled={loadingExport || !standards || standards.length === 0}
        sx={{ textTransform: 'none', fontSize: '0.75rem' }}
      >
        {loadingExport ? 'Exporting...' : 'Export to Google Sheet'}
      </Button>
      {spreadsheetUrl && (
        <Box sx={{ mt: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            <Link
              href={spreadsheetUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ fontSize: '0.75rem', wordBreak: 'break-all' }}
            >
              {spreadsheetUrl}
            </Link>
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export function ExportStandardsToSheet({
  state,
  subjectName,
}: ExportStandardsToSheetProps) {
  return (
    <GoogleLoginButton
      hideWhenLoggedIn={true}
      ParentComponent={({ children }) => (
        <Box sx={{ mt: 1, display: 'inline-block' }}>{children}</Box>
      )}
      LoggedInComponent={({ user: _user }: { user: firebase.User }) => (
        <ExportButtonContent state={state} subjectName={subjectName} />
      )}
    />
  )
}
